import Vue from "vue";

export default {
  createEmployee(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/employees/`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendInvite(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/employees/invite`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateEmployeeAfterInvite(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/organization/employees/${id}/profile`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateEmployee(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/organization/employees/${id}`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEmployeesById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/employees/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteEmployees(_, ids) {
    const params = {
      id: JSON.stringify(ids),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/organization/employees`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeEmployeeStatus(_, { ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/organization/employees/${endpoint}`, { id: ids })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEmployees({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
      };

      Vue.$http
        .get("/organization/employees", { params })
        .then(response => {
          commit(
            "employees",
            response.data.results ? response.data.results : response.data
          );
          commit("totalEmployees", response.data.total);
          commit("tableLoader", false);

          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error("Error message", {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getEmployees");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getEmployees");
  },
  handleSizeChangeForEmployeeTypes({ commit, dispatch, state }, perPage) {
    commit("employeeTypesPerPage", perPage);
    commit("employeeTypesCurrentPage", 1);
    dispatch("getEmployeeTypes", {
      perPage: state.employeeTypesPerPage,
      page: state.employeeTypesCurrentPage,
    });
  },

  handleCurrentChangeForEmployeeTypes({ commit, dispatch, state }, page) {
    commit("employeeTypesCurrentPage", page);
    dispatch("getEmployeeTypes", {
      perPage: state.employeeTypesPerPage,
      page: state.employeeTypesCurrentPage,
    });
  },
  handleSizeChangeForEmployeeGrades({ commit, dispatch, state }, perPage) {
    commit("employeeGradesPerPage", perPage);
    commit("employeeGradesCurrentPage", 1);
    dispatch("getEmployeeGrades", {
      perPage: state.employeeGradesPerPage,
      page: state.employeeGradesCurrentPage,
    });
  },

  handleCurrentChangeForEmployeeGrades({ commit, dispatch, state }, page) {
    commit("employeeGradesCurrentPage", page);
    dispatch("getEmployeeGrades", {
      perPage: state.employeeGradesPerPage,
      page: state.employeeGradesCurrentPage,
    });
  },
  handleSizeChangeForEmployeeDesignations(
    { commit, dispatch, state },
    perPage
  ) {
    commit("employeeDesignationsPerPage", perPage);
    commit("employeeDesignationsCurrentPage", 1);
    dispatch("getEmployeeDesignations", {
      perPage: state.employeeDesignationsPerPage,
      page: state.employeeDesignationsCurrentPage,
    });
  },

  handleCurrentChangeForEmployeeDesignations(
    { commit, dispatch, state },
    page
  ) {
    commit("employeeDesignationsCurrentPage", page);
    dispatch("getEmployeeDesignations", {
      perPage: state.employeeDesignationsPerPage,
      page: state.employeeDesignationsCurrentPage,
    });
  },

  handleSizeChangeForEmployeeCategories({ commit, dispatch, state }, perPage) {
    commit("employeeCategoriesPerPage", perPage);
    commit("employeeCategoriesCurrentPage", 1);
    dispatch("getEmployeesCategories", {
      perPage: state.employeeCategoriesPerPage,
      page: state.employeeCategoriesCurrentPage,
    });
  },

  handleCurrentChangeForEmployeeCategories({ commit, dispatch, state }, page) {
    commit("employeeCategoriesCurrentPage", page);
    dispatch("getEmployeesCategories", {
      perPage: state.employeeCategoriesPerPage,
      page: state.employeeCategoriesCurrentPage,
    });
  },
  addEmployeeTypes({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/employees/settings/types", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  editEmployeeTypes({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/employees/settings/types", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  deleteEmployeeType({ commit }, id) {
    commit("tableLoader", true);
    const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete("/organization/employees/settings/types", { params })
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getEmployeeTypes({ commit, state }, payload) {
    commit("tableLoader", true);
    const params = {
      ...(state.searchQuery != "" && {
        search_query: state.searchQuery,
      }),
      ...(payload && payload),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/types", { params })
        .then(response => {
          commit("tableLoader", false);
          commit(
            "employeeTypes",
            response.data.results ? response.data.results : response.data
          );
          commit("totalEmployeeTypes", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getEmployeesCategories({ commit, state }, payload) {
    const params = {
      ...(state.searchQuery !== "" && {
        search_query: state.searchQuery,
      }),
      ...(payload && payload),
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/categories", { params })
        .then(response => {
          commit(
            "employeeCategories",
            response.data.results ? response.data.results : response.data
          );
          commit("totalEmployeeCategories", response.data.total);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getEmployeeGrades({ commit, state }, payload) {
    commit("tableLoader", true);
    const params = {
      ...(state.searchQuery != "" && {
        search_query: state.searchQuery,
      }),
      ...(payload && payload),
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/grades", { params })
        .then(response => {
          commit("tableLoader", false);
          commit(
            "employeeGrades",
            response.data.results ? response.data.results : response.data
          );
          commit("totalEmployeeGrades", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getEmployeeDesignations({ commit, state }, payload) {
    const params = {
      ...(state.searchQuery != "" && {
        search_query: state.searchQuery,
      }),
      ...(payload && payload),
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/designations", { params })
        .then(response => {
          commit("tableLoader", false);
          commit(
            "employeeDesignations",
            response.data.results ? response.data.results : response.data
          );
          commit("totalEmployeeDesignations", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  addEmployeeDesignation({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/employees/settings/designations", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  editEmployeeDesignations({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/employees/settings/designations", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  deleteEmployeeDesignation({ commit }, id) {
    commit("tableLoader", true);
    const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete("/organization/employees/settings/designations", { params })
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  addEmployeeGrade({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/employees/settings/grades", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  editEmployeeGrade({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/employees/settings/grades", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  deleteEmployeeGrade({ commit }, id) {
    commit("tableLoader", true);
    const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete("/organization/employees/settings/grades", { params })
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  addEmployeesCategories({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/employees/settings/categories", payload)
        .then(response => {
          commit("employeeCategories", response.data);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  editEmployeeCategories({ commit }, payload) {
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/employees/settings/categories", payload)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  imageUpload(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/organization/employees/image-upload", data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteEmployeeCategories({ commit }, id) {
    commit("tableLoader", true);
    const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete("/organization/employees/settings/categories", { params })
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },

  getArchivedEmployees({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(payload && payload),
      };

      Vue.$http
        .get("/organization/employees/archives", { params })
        .then(response => {
          commit("archivedEmployees", response.data.results);
          commit("totalArchivedEmployees", response.data.total);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error("Error message", {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  handleSizeChangeForArchiveEmployee({ commit, dispatch, state }, perPage) {
    commit("archiveEmployeePerPage", perPage);
    commit("archiveEmployeeCurrentPage", 1);
    dispatch("getArchivedEmployees", {
      perPage: state.archiveEmployeePerPage,
      page: state.archiveEmployeeCurrentPage,
    });
  },

  handleCurrentChangeForArchiveEmployee({ commit, dispatch, state }, page) {
    commit("archiveEmployeeCurrentPage", page);
    dispatch("getArchivedEmployees", {
      perPage: state.archiveEmployeePerPage,
      page: state.archiveEmployeeCurrentPage,
    });
  },

  deleteArchivedEmployee({ commit }, id) {
    commit("tableLoader", true);
    const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/organization/employees/archives`, { params })
        .then(response => {
          commit("tableLoader", false);
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },

  restoreArchivedEmployee({ commit }, id) {
    commit("tableLoader", true);
    // const params = { id };
    return new Promise((resolve, reject) => {
      Vue.$http
        .put("/organization/employees/restore", { id })
        .then(response => {
          commit("tableLoader", false);
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
};
